import React, { useMemo, useContext, useCallback } from "react";
import FinancialContext, { TransactionModalsTypes } from "./FinancialContext";
import { CardInfoType, CustomerCard } from "./FinancialCards";
import { CustomerType } from "./FiMaTypes";
import {addCommas} from "@persian-tools/persian-tools"

const CustomerList: React.FC = () => {
  const { customers, openDetailModal } = useContext(FinancialContext);

  const theData: {
    id: number;
    cardInfo: CardInfoType;
    info: CustomerType;
  }[] = useMemo(() => {
    return customers.map((data, i) => ({
      id: data.id,
      info: data,
      cardInfo: [
        {
          label: "نام مشتری",
          value: data.name,
        },
        {
          label: "بدهکاری",
          value: `${addCommas(data.creditor)} تومان`,
        },
        {
          label: "بستانکاری",
          value: `${addCommas(data.indebtedness)} تومان`,
        },
        {
          label: "وضعیت مشتری",
          value: data.status,
        },
      ],
    }));
  }, [customers]);

  return (
    <>
      {theData.map((data) => (
        <CustomerCard
          key={`customer-card-${data.id}`}
          id={data.id}
          info={data.cardInfo}
          getReports={() =>
            openDetailModal(data.info, TransactionModalsTypes.DetailModal)
          }
          addTransaction={() =>
            openDetailModal(data.info, TransactionModalsTypes.AddTransaction)
          }
        />
      ))}
    </>
  );
};

export default CustomerList;
